import Vue from 'vue';
import {
    Avatar,
    Carousel,
    message,
    List,
    notification,
    Spin,
    Table,
    Button,
    Modal,
    Popover,
    tooltip,
    icon,
    row,
    col
} from 'ant-design-vue';

Vue.use(col);
Vue.use(row);
Vue.use(tooltip);
Vue.use(icon);
Vue.use(Popover);
Vue.use(Avatar);
Vue.use(Button);
Vue.use(Modal);
Vue.use(Carousel);
Vue.use(List);
Vue.use(message);
Vue.use(notification);
Vue.use(Spin);
Vue.use(Table);

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$spin = Spin;
